import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Courses from './components/Courses';
import Cambridge from './components/Cambridge';
import Method from './components/Method';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import EnglishIdPromo from './components/EnglishIdPromo';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import { MessageCircle } from 'lucide-react';
import { englishIdRoutes } from './english-id/routes';

const FloatingWhatsApp = () => (
  <a
    href="https://wa.me/59899200180"
    data-testid="floating-whatsapp-btn"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#20BD5A] text-white shadow-xl flex items-center justify-center transition-all hover:scale-110"
    aria-label="Contactar por WhatsApp"
  >
    <MessageCircle className="h-6 w-6" fill="currentColor" />
  </a>
);

const Home = () => (
  <div className="bg-[#FAF6EC] min-h-screen">
    <Header />
    <main>
      <Hero />
      <About />
      <Courses />
      <Cambridge />
      <Method />
      <Testimonials />
      <EnglishIdPromo />
      <Gallery />
      <Contact />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {englishIdRoutes}
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
